import { render, staticRenderFns } from "./MediaUploader.vue?vue&type=template&id=67dca78a"
import script from "./MediaUploader.vue?vue&type=script&lang=js"
export * from "./MediaUploader.vue?vue&type=script&lang=js"
import style0 from "./MediaUploader.vue?vue&type=style&index=0&id=67dca78a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports